import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { PageHeader } from "@/components/Doodles";
import { Opt, PostOpt, SeasonEditor, SeasonRow } from "@/components/SeasonEditor";

export default function SeasonsPage() {
  const [rows, setRows] = useState<SeasonRow[] | null>(null);
  const [posts, setPosts] = useState<PostOpt[]>([]);
  const [freebies, setFreebies] = useState<Opt[]>([]);
  const load = useCallback(() => { api.get("/admin/seasons").then((r) => setRows(r.data)).catch((e) => toast.error(formatApiError(e))); }, []);
  useEffect(() => {
    load();
    api.get("/admin/seasons/freebie-options").then((r) => setFreebies(r.data)).catch(() => setFreebies([]));
    api.get("/public/posts").then((r) => setPosts(r.data.map((p: PostOpt) => ({ slug: p.slug, title: p.title })))).catch(() => setPosts([]));
  }, [load]);
  return (
    <div data-testid="seasons-page">
      <PageHeader title="Seasons" kicker="The home page switches itself by date, a few weeks early for Pinterest planners" />
      {!rows && <p className="text-sm text-[#23324A]/60">Loading…</p>}
      <div className="space-y-5">
        {(rows || []).map((r) => <SeasonEditor key={r.key} row={r} posts={posts} freebies={freebies} onSaved={load} />)}
      </div>
    </div>
  );
}
